import React, { useEffect, useState } from 'react';
import SystemLabel from '../Systemlabel/SystemLabel';
import { showReportDialog } from '@sentry/browser';

const createDialogOptions = (clientName: string, lang: string, eventId: number) => ({
  lang: 'sv-SE',
  user: {
    name: clientName,
    lang,
    eventId,
  },
});

export default function ModuleFallback({
  error,
  resetError,
  eventId,
  clientName,
  lang,
}: {
  error: any;
  resetError: () => void;
  eventId: number;
  clientName: string;
  lang: string;
}) {
  const newDialogOptions = createDialogOptions(clientName, lang, eventId);

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleOnlineStatusChange);
    window.addEventListener('offline', handleOnlineStatusChange);

    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);
      window.removeEventListener('offline', handleOnlineStatusChange);
    };
  }, []);

  //   const errorBase64 = btoa(JSON.stringify(error, null, 2));

  return (
    <div className="flex w-full justify-center">
      <div className="m-auto flex flex-col justify-center">
        {isOnline ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="max-w-[40px] m-auto mb-4 fill-slate-700">
            <path d="M19 9H14V4H5V11.8571L6.5 13.25L10 9.5L13 14.5L15 12L18 15L15 14.5L13 17L10 13L7 16.5L5 15.25V20H19V9ZM21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8Z"></path>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="max-w-[40px] m-auto mb-4 fill-slate-700">
            <path d="M12.0001 18.0002C12.7144 18.0002 13.3704 18.2498 13.8856 18.6666L12.0001 21.0002L10.1145 18.6666C10.6297 18.2498 11.2857 18.0002 12.0001 18.0002ZM2.80766 1.39355L20.4853 19.0712L19.0711 20.4854L13.8913 15.3043C13.2967 15.107 12.6609 15.0002 12.0001 15.0002C10.5719 15.0002 9.26024 15.4991 8.22998 16.3323L6.97363 14.7761C8.24961 13.7443 9.84925 13.097 11.5964 13.0102L9.00025 10.4142C7.55273 10.8235 6.22651 11.5218 5.0878 12.4428L3.83099 10.8869C4.89946 10.0228 6.10763 9.3245 7.41633 8.8313L5.13168 6.54522C3.98878 7.08925 2.92058 7.76484 1.94666 8.5524L0.689453 6.99686C1.60358 6.25759 2.59156 5.60601 3.64058 5.05491L1.39345 2.80777L2.80766 1.39355ZM14.5004 10.2856L12.2165 8.00255L12 8.00012C15.0947 8.00012 17.9369 9.08154 20.1693 10.887L18.9123 12.4428C17.6438 11.4169 16.1427 10.6673 14.5004 10.2856ZM12.0001 3.00016C16.2849 3.00016 20.22 4.49731 23.3109 6.99703L22.0534 8.5524C19.3061 6.33074 15.8085 5.00016 12.0001 5.00016C11.122 5.00016 10.2604 5.07089 9.42075 5.20697L7.72455 3.511C9.09498 3.17714 10.5268 3.00016 12.0001 3.00016Z"></path>
          </svg>
        )}
        <span className="text-md text-center mb-2 m-auto">
          {isOnline ? <SystemLabel name="SomethingWentWrong" /> : <SystemLabel name="NoInternetConnection" />}
        </span>
        {/* <code className="p-4 bg-neutral-700 text-white text-xs rounded-md">
          {errorBase64}
          <button className='bg-transparent text-white'>
            <i className="ri-clipboard-line ri-md" />
          </button>
        </code> */}
        <div className="flex justify-center gap-x-2 mt-2">
          {isOnline && (
            <button className="text-sm rounded-md h-10 bg-[#2a9d8f] text-white" onClick={() => showReportDialog(newDialogOptions)}>
              <SystemLabel name="Report" />
            </button>
          )}
          <button className="text-sm rounded-md h-10" onClick={() => resetError()}>
            <SystemLabel name="RefreshModule" />
          </button>
        </div>
      </div>
    </div>
  );
}
